module.exports = __webpack_public_path__ + "img/10.2f18f0db.jpg";